export default __webpack_public_path__ + "static/media/m5.36dc532f.png";